/* tslint:disable */
/* eslint-disable */
/**
 * Scrivio ZorgMail Inbox API
 * The practice\'s own ZorgMail Secure e-mail mailbox, read inside Scrivio (ADR-050).  ZorgMail is the source of truth and Scrivio holds a disposable cache of it, kept in step by a sync every two minutes. Reads answer from that cache. A **state change** — read, unread, to the Prullenbak — is applied on the ZorgMail server first and only then in the cache; when the server refuses or cannot be reached, nothing changes and the error says why.  Read state is the server\'s `\\Seen` flag and is **shared by the whole practice**. Opening a message does not set it: the client asks for it with `markZorgMailInboxMessageSeen`, so a preview does not mark mail read for everyone.  Every message may concern any cliënt, so the inbox has a permission of its own, `zorgmail_inbox.read`, granted by default to the practice\'s Administrator only. Sending in the practice\'s name is a separate risk and a separate permission, `zorgmail_inbox.send`.  ## Authentication All endpoints require a Firebase Authentication JWT token in the `Authorization: Bearer <token>` header, and answer for the caller\'s active organisation only.  ## Error Responses All error responses follow RFC 7807 Problem Details format. A failure talking to ZorgMail carries a stable `code` extension — see `ZorgMailInboxProblemCode`. 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@scrivio.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';

export const BASE_PATH = "http://localhost:8080".replace(/\/+$/, "");

export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

export interface RequestArgs {
    url: string;
    options: RawAxiosRequestConfig;
}

export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected axios: AxiosInstance = globalAxios) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath ?? basePath;
        }
    }
};

export class RequiredError extends Error {
    constructor(public field: string, msg?: string) {
        super(msg);
        this.name = "RequiredError"
    }
}

interface ServerMap {
    [key: string]: {
        url: string,
        description: string,
    }[];
}

export const operationServerMap: ServerMap = {
}
